import { combineReducers } from 'redux';
// eslint-disable-next-line import/no-named-as-default-member
import app from './app';

export default combineReducers({ app });
